import { FaOptionIcon, NamedIconsType } from '@europrocurement/l2d-icons';
import { Box, Typography } from '@mui/material';
import * as React from 'react';

export type ModalFormTitleProps = { icon: NamedIconsType; title: string };

export const ModalFormTitle: React.FunctionComponent<ModalFormTitleProps> = function ({
    icon,
    title,
}) {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <FaOptionIcon
                {...icon.props}
                sx={{ marginRight: '12px' }}
            />
            <Typography fontSize={18}>{title}</Typography>
        </Box>
    );
};
